import { Action } from 'redux'
import { CONFIG_LOAD_FILE, CONFIG_SET } from '../constants/ActionTypes'
import { Device } from '../model/Device'
import { ISettings } from '../services/hashParser'

export interface IActionLoadConfig extends Action {
  type: typeof CONFIG_LOAD_FILE
  settings: ISettings
}

export const loadConfigFile = (settings: ISettings): IActionLoadConfig => ({
  type: CONFIG_LOAD_FILE,
  settings,
})

export interface IConfig extends ISettings {
  device: Device,
}

export interface IActionConfigSet extends Action {
  type: typeof CONFIG_SET
  settings: IConfig
}

export const setConfig = (settings: IConfig): IActionConfigSet => ({
  type: CONFIG_SET,
  settings,
})
